var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vkb-nak-chart" },
    [
      _c("highcharts", {
        ref: "highcharts",
        attrs: {
          options: _vm.type === "pie" ? _vm.pieChartOptions : _vm.chartOptions
        }
      }),
      _vm.level > 0
        ? _c(
            "a",
            {
              staticClass: "btn-back",
              on: {
                click: function($event) {
                  _vm.$emit("go-back")
                }
              }
            },
            [_vm._v("< Go back to Level " + _vm._s(_vm.level))]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02aa921d", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02aa921d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/index/chart.vue
// module id = 3rfq
// module chunks = 0